export default __webpack_public_path__ + "static/media/album-image-4.ace1f4bf.svg";